"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORMATS = void 0;
exports.IonAd = IonAd;
exports.IonAdSlot = IonAdSlot;
exports.clearSlots = clearSlots;
exports["default"] = void 0;
exports.disableAgeTarget = disableAgeTarget;
exports.disableAnchorAds = disableAnchorAds;
exports.disableArticleLevelTarget = disableArticleLevelTarget;
exports.disableGenderTarget = disableGenderTarget;
exports.disableInterstitial = disableInterstitial;
exports.disableMappings = disableMappings;
exports.disableSectionLevelTarget = disableSectionLevelTarget;
exports.enableAgeTarget = enableAgeTarget;
exports.enableAnchorAds = enableAnchorAds;
exports.enableArticleLevelTarget = enableArticleLevelTarget;
exports.enableGenderTarget = enableGenderTarget;
exports.enableInterstitial = enableInterstitial;
exports.enableLazyLoad = enableLazyLoad;
exports.enableMappings = enableMappings;
exports.enableSectionLevelTarget = enableSectionLevelTarget;
exports.enableSingleRequest = enableSingleRequest;
exports.getSlots = getSlots;
exports.isAnchorAdsEnabled = isAnchorAdsEnabled;
exports.performSingleRequest = performSingleRequest;

var _react = _interopRequireWildcard(require("react"));

var _useHasMounted = _interopRequireDefault(require("./useHasMounted"));

var _ionMedia = require("ion-media");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var slots = {};
var refreshingSlots = [];
var events = [];
var options = {
  enableSingleRequest: false,
  enableLazyLoad: false,
  enableAnchorAds: false,
  enableMappings: false,
  enableInterstitial: false,
  enableGenderTarget: false,
  enableAgeTarget: false,
  enableArticleLevelTarget: false,
  enableSectionLevelTarget: false
};

if (typeof window !== 'undefined') {
  window.googletag = window.googletag || {
    cmd: []
  };
}

function getSlots() {
  return slots;
}

var FORMATS = {
  leaderboard: {
    desktop: [[728, 90], [970, 90], [970, 250]],
    tablet: [[728, 90]],
    mobile: [[320, 50], [300, 50]]
  },
  mpudynamic: {
    desktop: [[300, 250], [300, 600]],
    tablet: [[300, 250]],
    mobile: [[300, 250], [336, 280]]
  },
  mpusection: {
    tablet: [[300, 250]],
    mobile: [[300, 250]]
  },
  mpu: {
    desktop: [[300, 250]],
    tablet: [[300, 250]],
    mobile: [[300, 250], [336, 280]]
  },
  inarticle: {
    desktop: [[300, 250]],
    tablet: [[300, 250]],
    mobile: [[300, 250], [336, 280]]
  }
};
exports.FORMATS = FORMATS;

function clearSlots() {
  if (typeof window !== 'undefined') {
    console.warn('### CLEARING ALL AD SLOTS ###');
    var _window = window,
        _googletag = _window.googletag;

    _googletag.cmd.push(function () {
      events.forEach(function (item) {
        return _googletag.pubads().removeEventListener('slotRenderEnded', item);
      });
      events.forEach(function (item) {
        return _googletag.pubads().removeEventListener('slotRequested', item);
      });

      _googletag.destroySlots();
    });

    slots = {};
    refreshingSlots = [];
  }
}

function enableSingleRequest() {
  options.enableSingleRequest = true;
}

function enableLazyLoad() {
  options.enableLazyLoad = true;
}

function performSingleRequest(slotId) {
  googletag.cmd.push(function () {
    googletag.display(slotId);
  });
}

function enableAnchorAds() {
  options.enableAnchorAds = true;
}

function enableMappings() {
  options.enableMappings = true;
}

function disableAnchorAds() {
  options.enableAnchorAds = false;
}

function disableMappings() {
  options.enableMappings = false;
}

function isAnchorAdsEnabled() {
  return options.enableAnchorAds;
}

function enableInterstitial() {
  options.enableInterstitial = true;
}

function disableInterstitial() {
  options.enableInterstitial = false;
}

function enableGenderTarget() {
  options.enableGenderTarget = true;
}

function disableGenderTarget() {
  options.enableGenderTarget = false;
}

function enableAgeTarget() {
  options.enableAgeTarget = true;
}

function disableAgeTarget() {
  options.enableAgeTarget = false;
}

function enableArticleLevelTarget() {
  options.enableArticleLevelTarget = true;
}

function disableArticleLevelTarget() {
  options.enableArticleLevelTarget = true;
}

function enableSectionLevelTarget() {
  options.enableSectionLevelTarget = true;
}

function disableSectionLevelTarget() {
  options.enableSectionLevelTarget = true;
}

function IonAdSlot(_ref) {
  var slotId = _ref.slotId,
      path = _ref.path,
      targeting = _ref.targeting,
      className = _ref.className,
      sizes = _ref.sizes,
      mapping = _ref.mapping,
      anchor = _ref.anchor,
      refreshTime = _ref.refreshTime,
      collapseEmptyDiv = _ref.collapseEmptyDiv,
      onSlotRequested = _ref.onSlotRequested,
      onSlotRenderEnded = _ref.onSlotRenderEnded,
      onAdSlotRegistered = _ref.onAdSlotRegistered;
  (0, _react.useEffect)(function () {
    var _window2 = window,
        googletag = _window2.googletag;

    var __onSlotRenderEnded = function __onSlotRenderEnded(event) {
      if (event.slot) {
        var _targeting = [];

        _targeting.push(Object.getOwnPropertyNames(targeting)[0]);

        _targeting.push(targeting[_targeting[0]]);

        if (event.slot === slots[slotId]) {
          var _sizes = sizes.map(function (elem) {
            return elem.join('x');
          }).join('|');

          console.log('### Ad Rendered:', 'targeting:', _targeting.join(':'), 'path:', path, 'sizes:', _sizes, 'mapping:', mapping, 'isEmpty:', event.isEmpty, 'event:', event);

          if (onSlotRenderEnded) {
            onSlotRenderEnded(event);
          }
        }
      }
    };

    var __slotRequested = function __slotRequested(event) {
      if (event.slot === slots[slotId] && onSlotRequested) {
        event.sizes = sizes;
        event.sizeMapping = mapping;
        event.slotId = slotId;
        onSlotRequested(event);
      }
    };

    googletag.cmd.push(function () {
      events.push(__onSlotRenderEnded);
      events.push(__slotRequested);
      googletag.pubads().addEventListener('slotRenderEnded', __onSlotRenderEnded);
      googletag.pubads().addEventListener('slotRequested', __slotRequested);
    });
  }, []);
  (0, _react.useEffect)(function () {
    var _window3 = window,
        googletag = _window3.googletag;
    googletag.cmd.push(function () {
      googletag.pubads().addEventListener('impressionViewable', function (event) {
        var slot = event.slot;

        if (slot.getTargeting('refresh').indexOf('true') > -1) {
          var targetingKeys = slot.getTargetingKeys();

          if (refreshingSlots.indexOf(slot) < 0) {
            var secondsToWait = slot.getTargeting('refreshTime')[0];
            console.log('### Scheduling slot refresh in', secondsToWait, 'seconds -', targetingKeys[0], ':', slot.getTargeting(targetingKeys[0]));
            refreshingSlots.push(slot);
            setTimeout(function () {
              googletag.pubads().refresh([slot]);
              var idx = refreshingSlots.indexOf(slot);

              if (idx >= 0) {
                refreshingSlots.splice(idx, 1);
              }
            }, secondsToWait * 1000);
          }
        }
      });
    });
  }, []); // Configure and setup the slot

  (0, _react.useEffect)(function () {
    var _window4 = window,
        googletag = _window4.googletag; // Do not redeclare slots

    if (!slots[slotId]) {
      slots[slotId] = 'pending';
      var _targeting = [];

      if (targeting) {
        _targeting.push(Object.getOwnPropertyNames(targeting)[0]);

        _targeting.push(targeting[_targeting[0]]);
      }

      googletag.cmd.push(function () {
        try {
          var slot;

          switch (anchor) {
            case 'top':
              slot = googletag.defineOutOfPageSlot(path, googletag.enums.OutOfPageFormat.TOP_ANCHOR);
              break;

            case 'bottom':
              slot = googletag.defineOutOfPageSlot(path, googletag.enums.OutOfPageFormat.BOTTOM_ANCHOR);
              break;

            case 'interstitial':
              if (options.enableInterstitial) {
                slot = googletag.defineOutOfPageSlot(path, googletag.enums.OutOfPageFormat.INTERSTITIAL);
                slot.addService(googletag.pubads()).setConfig({
                  interstitial: {
                    triggers: {
                      navBar: true,
                      unhideWindow: true
                    }
                  }
                });
              }

              break;

            default:
              slot = googletag.defineSlot(path, sizes, slotId);
          }

          if (!slot) {
            console.error('### ERROR: Unable to create slot', {
              anchor: anchor,
              path: path,
              sizes: sizes,
              slotId: slotId
            });
            return;
          }

          if (mapping && options.enableMappings) {
            slot.defineSizeMapping(mapping);
          }

          slot.setCollapseEmptyDiv(!!collapseEmptyDiv);
          slot.addService(googletag.pubads());

          if (_targeting.length) {
            slot.setTargeting(_targeting[0], _targeting[1]);
          }

          if (refreshTime) {
            slot.setTargeting('refresh', 'true');
            slot.setTargeting('refreshTime', refreshTime);
          }

          slots[slotId] = slot;

          if (onAdSlotRegistered) {
            onAdSlotRegistered(slotId);
          }

          if (options.enableLazyLoad) {
            // googletag.pubads().disableInitialLoad()
            googletag.pubads().enableLazyLoad({
              fetchMarginPercent: 200,
              renderMarginPercent: 100,
              mobileScaling: 1.0
            });
          }

          if (options.enableSingleRequest) {
            googletag.pubads().enableSingleRequest();
          } else {
            googletag.cmd.push(function () {
              googletag.display(slotId);
            });
          }

          if (options.enableArticleLevelTarget) {
            googletag.pubads().setTargeting('contentKey', []);
          }

          if (options.enableSectionLevelTarget) {
            googletag.pubads().setTargeting('Section', []);
          }

          if (options.enableAgeTarget) {
            googletag.pubads().setTargeting('Age', []);
          }

          if (options.enableGenderTarget) {
            googletag.pubads().setTargeting('Gender', []);
          }

          googletag.enableServices();
        } catch (e) {
          console.error(e.message);

          var _sizes = sizes.map(function (elem) {
            return elem.join('x');
          }).join('|');

          console.error('slotId:', {
            anchor: anchor,
            targeting: _targeting.join(':'),
            path: path,
            sizes: _sizes
          });
        }
      });
    }
  }, [targeting, path, sizes, slotId, collapseEmptyDiv, onSlotRenderEnded]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: slotId,
    className: className
  });
}

function IonAd(_ref2) {
  var slotId = _ref2.slotId,
      path = _ref2.path,
      targeting = _ref2.targeting,
      refreshTime = _ref2.refreshTime,
      className = _ref2.className,
      adNotice = _ref2.adNotice,
      mapping = _ref2.mapping,
      anchor = _ref2.anchor,
      desktop = _ref2.desktop,
      tablet = _ref2.tablet,
      mobile = _ref2.mobile,
      collapseEmptyDiv = _ref2.collapseEmptyDiv,
      onSlotRequested = _ref2.onSlotRequested,
      onSlotRenderEnded = _ref2.onSlotRenderEnded,
      onAdSlotRegistered = _ref2.onAdSlotRegistered;
  var debug = !process.env.RAZZLE_ENABLE_GAM;
  var _targeting = [];

  _targeting.push(Object.getOwnPropertyNames(targeting)[0]);

  _targeting.push(targeting[_targeting[0]]);

  if ((anchor === 'top' || anchor === 'bottom') && !options.enableAnchorAds) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_useHasMounted["default"], null, !debug && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ionMedia.Desktop, null, desktop && desktop.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: className || 'advert'
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, adNotice && /*#__PURE__*/_react["default"].createElement("small", null, "Advertisement"), /*#__PURE__*/_react["default"].createElement(IonAdSlot, {
    targeting: targeting,
    path: path,
    sizes: desktop,
    mapping: mapping,
    refreshTime: refreshTime,
    collapseEmptyDiv: collapseEmptyDiv,
    slotId: slotId,
    className: "",
    anchor: anchor,
    onSlotRenderEnded: onSlotRenderEnded,
    onSlotRequested: onSlotRequested,
    onAdSlotRegistered: onAdSlotRegistered
  })))), /*#__PURE__*/_react["default"].createElement(_ionMedia.Tablet, null, tablet && tablet.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: className || 'advert'
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, adNotice && /*#__PURE__*/_react["default"].createElement("small", null, "Advertisement"), /*#__PURE__*/_react["default"].createElement(IonAdSlot, {
    targeting: targeting,
    path: path,
    sizes: tablet,
    mapping: mapping,
    refreshTime: refreshTime,
    collapseEmptyDiv: collapseEmptyDiv,
    slotId: slotId,
    className: "",
    anchor: anchor,
    onSlotRenderEnded: onSlotRenderEnded,
    onSlotRequested: onSlotRequested,
    onAdSlotRegistered: onAdSlotRegistered
  })))), /*#__PURE__*/_react["default"].createElement(_ionMedia.Mobile, null, mobile && mobile.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: className || 'advert'
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, adNotice && /*#__PURE__*/_react["default"].createElement("small", null, "Advertisement"), /*#__PURE__*/_react["default"].createElement(IonAdSlot, {
    targeting: targeting,
    path: path,
    sizes: mobile,
    mapping: mapping,
    refreshTime: refreshTime,
    collapseEmptyDiv: collapseEmptyDiv,
    slotId: slotId,
    className: "",
    anchor: anchor,
    onSlotRenderEnded: onSlotRenderEnded,
    onSlotRequested: onSlotRequested,
    onAdSlotRegistered: onAdSlotRegistered
  }))))), debug && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ionMedia.Desktop, null, desktop && desktop.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, adNotice && /*#__PURE__*/_react["default"].createElement("small", null, "Advertisement"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    src: '//via.placeholder.com/' + desktop.reduce(function (p, c) {
      if (p[0] * p[1] > c[0] * c[1]) {
        return p;
      } else {
        return c;
      }
    }).join('x') + '?text=' + _targeting.join(':'),
    alt: ""
  }))))), /*#__PURE__*/_react["default"].createElement(_ionMedia.Tablet, null, tablet && tablet.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, adNotice && /*#__PURE__*/_react["default"].createElement("small", null, "Advertisement"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    className: "advert",
    src: '//via.placeholder.com/' + tablet.reduce(function (p, c) {
      if (p[0] * p[1] > c[0] * c[1]) {
        return p;
      } else {
        return c;
      }
    }).join('x') + '?text=' + _targeting.join(':'),
    alt: ""
  }))))), /*#__PURE__*/_react["default"].createElement(_ionMedia.Mobile, null, mobile && mobile.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, adNotice && /*#__PURE__*/_react["default"].createElement("small", null, "Advertisement"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    className: "advert",
    src: '//via.placeholder.com/' + mobile.reduce(function (p, c) {
      if (p[0] * p[1] > c[0] * c[1]) {
        return p;
      } else {
        return c;
      }
    }).join('x') + '?text=' + _targeting.join(':'),
    alt: ""
  })))))));
}

var _default = IonAd;
exports["default"] = _default;